(function () {
  function initTestimonialSwiper(el) {
    var sectionId = el.id.replace('testimonials-swiper-', '');
    var cfg = (window.tcSectionSettings && window.tcSectionSettings[sectionId]) || {};

    if (el.dataset.tcInitialized) return;
    el.dataset.tcInitialized = 'true';

    new Swiper(el, {
      slidesPerView: cfg.slidesPerViewMobile || 1.15,
      spaceBetween: cfg.spaceBetween || 8,
      loop: !!cfg.loop,
      followFinger: true,
      autoplay: cfg.autoplay
        ? { delay: cfg.autoplayDelay || 5000, disableOnInteraction: false }
        : false,
      pagination: {
        el: el.querySelector('.testimonials-custom__pagination'),
        type: 'progressbar'
      },
      breakpoints: {
        990: {
          slidesPerView: cfg.slidesPerViewDesktop || 3.2,
          spaceBetween: (cfg.spaceBetween || 8) * 2
        }
      }
    });
  }

  function initAll() {
    if (typeof Swiper === 'undefined') return;
    document
      .querySelectorAll('.testimonials-custom__slider')
      .forEach(initTestimonialSwiper);
  }

  window.tcInitAll = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after Shopify theme editor section re-renders
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.testimonials-custom__slider');
    if (el) initTestimonialSwiper(el);
  });
})();
